/** Official ICS 213RR-CG priority: Urgent (U) or Routine (R). */

export const ICS213RR_PRIORITY_URGENT = 'Urgent';
export const ICS213RR_PRIORITY_ROUTINE = 'Routine';

export const ICS213RR_PRIORITY_OPTIONS = [
  { value: ICS213RR_PRIORITY_URGENT, label: 'Urgent (U)' },
  { value: ICS213RR_PRIORITY_ROUTINE, label: 'Routine (R)' },
] as const;

const URGENT_ALIASES = new Set([
  'u',
  'urgent',
  'high',
  'critical',
  'high priority',
]);

const ROUTINE_ALIASES = new Set([
  'r',
  'routine',
  'low',
  'medium',
  'low priority',
]);

/** Map stored or UI values onto the printed U/R priority. */
export function normalize213rrPriority(
  value: string | null | undefined
): string {
  if (!value) return '';
  const key = value.trim().toLowerCase();
  if (URGENT_ALIASES.has(key)) return ICS213RR_PRIORITY_URGENT;
  if (ROUTINE_ALIASES.has(key)) return ICS213RR_PRIORITY_ROUTINE;
  if (value === ICS213RR_PRIORITY_URGENT || value === ICS213RR_PRIORITY_ROUTINE) {
    return value;
  }
  return value;
}

export function itemDescription(
  item: { description?: string | null; name?: string | null } | null | undefined
): string {
  return (item?.description || item?.name || '').trim();
}
